import Vue from 'vue'

const sharedState = Vue.observable({
	xs: false,
	sm: false,
	md: false,
	lg: false,
	xl: false
})

let initialized = false

function initBreakpoints () {
	if (initialized) return
	initialized = true

	// Match your SCSS breakpoints exactly
	const mqXS = window.matchMedia('(max-width: 575px)')           // 0-575px
	const mqSM = window.matchMedia('(max-width: 767px)')  // 576-767px
	const mqMD = window.matchMedia('(max-width: 991px)')  // 768-991px
	const mqLG = window.matchMedia('(max-width: 1299px)') // 992-1299px
	const mqXL = window.matchMedia('(min-width: 1300px)')         // 1300px+

	const update = () => {
		sharedState.xs = mqXS.matches
		sharedState.sm = mqSM.matches
		sharedState.md = mqMD.matches
		sharedState.lg = mqLG.matches
		sharedState.xl = mqXL.matches
	}

	mqXS.addEventListener('change', update)
	mqSM.addEventListener('change', update)
	mqMD.addEventListener('change', update)
	mqLG.addEventListener('change', update)
	mqXL.addEventListener('change', update)

	update()
}

export default {
	computed: {
		$breakpoints () {
			return sharedState
		}
	},
	created () {
		initBreakpoints()
	}
}
